type LinkPhonenumberProps = {
    phoneNumber: string | undefined;
};

const LinkPhonenumber = ({ phoneNumber }: LinkPhonenumberProps) => {
    return <a href={`tel:+45${phoneNumber?.replace(/\s/g, '')}`}>{phoneNumber}</a>;
};

export default LinkPhonenumber;
